<div class="buttons">
  <div class="refresh-page">
    <button (click)="refreshPage()">
      <svg-icon
        src="assets/img/refresh_page.svg"
        [svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
      ></svg-icon
      ><span>{{ 'label.RenewAnnouncement' | translate }}</span>
    </button>
    <div class="jobseeker-profile">
      <a
        [href]="
          providerWebsiteMap[providerWebsiteId] +
          'admin/jobseeker-edit/' +
          jobseekerId
        "
        target="_blank"
        ><svg-icon
          src="assets/img/go_to_company_profile.svg"
          [svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
        ></svg-icon
        ><span>{{ 'label.GoToJobseekerProfile' | translate }}</span></a
      >
    </div>
  </div>
  <div class="buttons-head">
    <div class="button-container">
      <button class="approve" (click)="onApprove(jobseekerModerationId)">
        {{ 'label.ConfirmChanges' | translate }}
      </button>
      <button class="reject" (click)="onReject(jobseekerModerationId)">
        {{ 'label.Reject' | translate }}
      </button>
    </div>
  </div>
</div>
